import React, { useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import RecordContext from '../../context/record/recordContext';
import TopNav from '../nav/TopNav';
import RecordLabelNav from './RecordLabelNav';
import MainFooter from '../nav/MainFooter';

const RecordArtists = () => {
  const recordContext = useContext(RecordContext);
  const { artists } = recordContext;
  return (
    <Container className='Record-arts' fluid>
      <TopNav />
      <RecordLabelNav />
      <Container>
        <Row className='arts-list'>
          {artists.map((arts) => (
            <div key={arts.id} className='border border-light'>
              <img src={arts.src} alt='' width='100%' height='100%' />
            </div>
          ))}
        </Row>
      </Container>
      <MainFooter />
    </Container>
  );
};
export default RecordArtists;
